export function isUnauthenticatedRoute(url: string): boolean {
  const path = url.split(/[?#]/)[0];
  return /^\/mobile-barcodes\/[0-9]+\/?$/.test(path);
}
